import { Flex, Segmented } from 'antd'
import { useState } from 'react'

import { GetQuestionnaireResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { useStyles } from 'src/features/persons/pages/quiz/styles'
import { useLocales } from 'src/locales'

import { DetailsAnswerCard } from './DetailsAnswerCard'

type Props = {
  data?: GetQuestionnaireResponse
}

export const QuizDetailsForm = ({ data }: Props) => {
  const { styles } = useStyles()
  const { currentLang } = useLocales()
  const [previewLang, setPreviewLang] = useState(currentLang?.value)

  return (
    <Flex vertical gap={48}>
      <Flex gap={8} justify="space-between" align="center">
        <Text className={styles.quizTitle} weight={700}>
          {data?.name?.[previewLang]}
        </Text>

        <Segmented
          options={['ro', 'ru']}
          value={previewLang}
          onChange={setPreviewLang}
        />
      </Flex>

      {data?.questions?.map(
        (question: GetQuestionnaireResponse, index: number) => (
          <Flex vertical gap={16} key={question?.id}>
            <Text className={styles.questionTitle}>
              {index + 1}. {question?.text?.[previewLang]}
            </Text>
            <DetailsAnswerCard question={question} previewLang={previewLang} />
          </Flex>
        )
      )}
    </Flex>
  )
}
